import { render } from "./Created.vue?vue&type=template&id=90402e6c"
import script from "./Created.vue?vue&type=script&lang=js"
export * from "./Created.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__